"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextJsPageViewTracker = void 0;
const tslib_1 = require("tslib");
const router_1 = require("next/router");
const react_1 = tslib_1.__importStar(require("react"));
const page_view_tracker_1 = require("./page-view-tracker");
function getTrackPageOverrides(prevPath) {
    const href = globalThis?.location?.href;
    if (!prevPath || !href) {
        return {};
    }
    try {
        return { referrer: new URL(prevPath, href).href };
    }
    catch {
        return {};
    }
}
function NextJsPageViewTracker({ context, }) {
    const router = (0, router_1.useRouter)();
    const prevPath = (0, react_1.useRef)(null);
    const storePath = (0, react_1.useCallback)(() => {
        prevPath.current = globalThis?.location?.pathname ?? null;
    }, [prevPath]);
    (0, react_1.useEffect)(() => {
        router.events.on('beforeHistoryChange', storePath);
        return () => router.events.off('beforeHistoryChange', storePath);
    }, [router.events, storePath]);
    const getTrackPageData = (0, react_1.useCallback)(() => {
        return getTrackPageOverrides(prevPath.current);
    }, []);
    const registerOnPageView = (0, react_1.useCallback)((onPageView) => {
        const onPageViewDelayed = () => {
            setTimeout(onPageView, 0);
        };
        router.events.on('routeChangeComplete', onPageViewDelayed);
        return () => router.events.off('routeChangeComplete', onPageViewDelayed);
    }, [router.events]);
    return (react_1.default.createElement(page_view_tracker_1.PageViewTracker, { registerOnPageView: registerOnPageView, getTrackPageData: getTrackPageData, context: context }));
}
exports.NextJsPageViewTracker = NextJsPageViewTracker;
//# sourceMappingURL=next-js-page-view-tracker.js.map